(ns frontend.view.grid.exit-opportunities-grid.events
  (:require
   [common.attribute :as attribute]
   [common.localization :as loc]
   [common.schema.entity-type-names :as entity-type-names]
   [common.schema.entity-types :as entity-types]
   [common.schema.registry :as registry]
   [common.util :as cu]
   [frontend.actions.named-view :as named-view-actions]
   [frontend.actions.exit-opportunity :as exit-opportunity-actions]
   [frontend.conn :as conn]
   [frontend.local-storage :as ls]
   [frontend.logging :as logging]
   [frontend.react.virtualized.scrollable-grid.common :as grid]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.state.permissions :as f-permissions]
   [frontend.utils :as fu]
   [frontend.view.grid.investors-grid.events :as investors-events]
   [frontend.view.grid.holdings-grid.events :as holdings-events]
   [frontend.view.grid.exit-opportunities-grid.columns :as columns]
   [frontend.view.grid.exit-opportunities-grid.db :as db]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.view.modals.events :as modals]
   [potpuri.core :refer [fn->]]
   [promesa.core :as p]
   [reagent.core :as r]))

(defn system-views
  []
  [{:named-view/settings {:selected-columns columns/default-columns
                          :ordered-columns  columns/ordered-default-columns
                          :card-settings
                          {:footer-1
                           :exit-opportunity/datetime-expected-closing-date}
                          :view-mode        :board-mode
                          :filters          {:exit-opportunity/status
                                             {:operand :operand/any-of
                                              :lower-bound-value
                                              #{:exit-opportunity.status/active}}}
                          :sort-by          :exit-opportunity/name
                          :sort-direction   "DESC"}
    :named-view/name (loc/tr :active-pipeline)
    :disable-delete? true
    :db/id "named-view-exit-active-pipeline"}
   {:named-view/settings {:selected-columns columns/default-columns
                          :ordered-columns  columns/ordered-default-columns
                          :view-mode        :grid-mode
                          :sort-by          :exit-opportunity/name
                          :sort-direction   "ASC"}
    :named-view/name (loc/tr :all-exit-opportunities)
    :disable-delete? true
    :db/id "named-view-exit-all-opportunities"}
   {:named-view/settings
    {:selected-columns columns/my-exit-opportunities-columns
     :ordered-columns  columns/my-exit-opportunities-ordered-columns
     :view-mode        :grid-mode
     :sort-by          :exit-opportunity/name
     :sort-direction   "ASC"
     :filters          {:exit-opportunity/owner {:operand :operand/any-of
                                                 :lower-bound-value #{@session/account-id}}}}
    :named-view/name (loc/tr :my-exit-opportunities)
    :disable-delete? true
    :db/id "named-view-my-exit-opportunities"}

   {:named-view/settings {:selected-columns columns/lost-exit-opportunities-columns
                          :ordered-columns  columns/lost-exit-opportunities-ordered-columns
                          :view-mode        :grid-mode
                          :filters          {:exit-opportunity/status
                                             {:operand :operand/any-of
                                              :lower-bound-value #{:exit-opportunity.status/lost}}}
                          :sort-by          :exit-opportunity/lost-on
                          :sort-direction   "DESC"}
    :named-view/name (loc/tr :lost-exit-opportunities)
    :disable-delete? true
    :db/id "named-view-lost-exit-opportunities"}
   {:named-view/settings {:selected-columns columns/exit-opportunities-on-hold-columns
                          :ordered-columns  columns/exit-opportunities-on-hold-ordered-columns
                          :view-mode        :grid-mode
                          :filters          {:exit-opportunity/status
                                             {:operand :operand/any-of
                                              :lower-bound-value
                                              #{:exit-opportunity.status/on-hold}}}
                          :sort-by          :exit-opportunity/put-on-hold-on
                          :sort-direction   "DESC"}
    :named-view/name (loc/tr :exit-opportunities-on-hold)
    :disable-delete? true
    :db/id "named-view-exit-opportunities-on-hold"}])

(defn system-views-by-id
  []
  (->> (system-views)
       (map (fn [v]
              [(:db/id v) v]))
       (into {})))

(defn named-views
  []
  (concat (system-views)
          (->> @session/all-named-views
               (cu/only-entity :named-view/view :exit-opportunities-grid)
               (sort-by :common/created-on))))

(defn named-view-by-id
  [id]
  (or (get @session/entities id)
      (get (system-views-by-id) id)))

(defn ls-path
  [& rest]
  (concat
   [(:db/id @session/account)
    (:db/id @session/tenant)
    :exit-opportunities-view-settings]
   rest))

(declare setup-column-state!)

(defn load-view!
  [named-view] ;;named-view entity
  (let [{:keys [named-view/settings]} named-view]
    (ls/set-in (ls-path) settings)
    (setup-column-state! settings)))

(defn save-current-view!
  [name]
  (let [settings @db/view-settings
        msg {:named-view/name     name
             :named-view/view     :exit-opportunities-grid
             :named-view/settings settings}]
    (named-view-actions/*create-named-view->
     msg
     identity
     (fn [& a] ;;TODO show error message
       (logging/error "create-named-view failed" a)))))

(defn get-label
  [k]
  (let [;;TODO only investor - cleanup
        buyer-types [:entity.type/investor]
        tenant-schema @session/tenant-schema
        ref-field? (vector? k)
        [_ buyer-field] (when (and (vector? k)
                                   (= (first k)
                                      :exit-opportunity/buyer))
                          k)
        buyer-fs (when buyer-field
                   (registry/get-field-schema tenant-schema buyer-field))]
    (cond
      (nil? k)
      nil

      (keyword? k)
      (let [fs (registry/get-field-schema tenant-schema k)]
        (loc/field-name k fs))

      (and ref-field?
           (= (count buyer-types) 1))
      (attribute/attribute-label tenant-schema k)

      (and ref-field?
           (> (count buyer-types) 1)
           (contains? #{"common" "buyer"} (namespace buyer-field)))
      (attribute/attribute-label tenant-schema k)

      (and ref-field?
           (> (count buyer-types) 1)
           (contains? #{"company" "asset"} (namespace buyer-field)))
      (loc/tr :buyer-field-specified
          [(loc/tr :company-lc) (loc/field-name buyer-field buyer-fs)])

      (and ref-field?
           (> (count buyer-types) 1)
           (contains? #{"person"} (namespace buyer-field)))
      (loc/tr :buyer-field-specified
          [(loc/tr :person-lc) (loc/field-name buyer-field buyer-fs)])

      (and ref-field?
           (> (count buyer-types) 1)
           (contains? #{"investor"} (namespace buyer-field)))
      (loc/tr :buyer-field-specified
          [(loc/tr :investor-lc) (loc/field-name buyer-field buyer-fs)])

      :else
      (attribute/attribute-label tenant-schema k))))

(defn precalculated-schema
  [recalculate?]
  (let [calculated @db/schema
        pipeline @session/selected-exit-oppo-pipeline
        schema (cond
                 (and (not recalculate?)
                      calculated)
                 calculated
                 :else
                 (->>
                  (registry/get-schema @session/tenant-schema :entity.type/exit-opportunity)
                  (remove
                   (fn [[k v]]
                     (let [grid-visibility (->> v
                                                :field/default-visibility
                                                :grid)
                           not-available?
                           (or (columns/not-available k)
                               (nil? grid-visibility)
                               (= grid-visibility :editor.type/none)
                               (if (or (not= (:field/data-type v) :data.type/currency-symbol)
                                       (not (:field/secondary-field? v)))
                                 (not (f-permissions/field-read-access?
                                       k
                                       :entity.type/exit-opportunity
                                       pipeline))
                                 (not (f-permissions/field-read-access?
                                       (:field/related-fields v)
                                       :entity.type/exit-opportunity
                                       pipeline))))]
                       not-available?)))
                  (sort-by (fn [[k v]]
                             (-> v
                                 :field/translations
                                 :en)))))
        ref-schema
        (fn [entity-type]
          (when (or recalculate?
                    (not calculated))
            (->> (case entity-type
                   :entity.type/investor
                   (investors-events/precalculated-schema recalculate?)
                   :entity.type/holding
                   (holdings-events/precalculated-schema recalculate?)
                   nil)
                 (remove (fn [[k v]]
                           ;; note: pipeline as nil since buyer or target-holding
                           ;; are not considered as target-assets => not configurable
                           ;; in pipeline's field-settings
                           (if (not= (:field/data-type v) :data.type/currency-symbol)
                             (not (f-permissions/field-read-access? k
                                                                    entity-type
                                                                    nil))
                             (not (f-permissions/field-read-access? (:field/related-fields v)
                                                                    entity-type
                                                                    nil))))))))
        buyer-schema (->> (ref-schema :entity.type/investor)
                          (keep (fn [[k v]]
                                  ;; only one chain of indirection for simplicity
                                  ;; (i.e. don't include [:exit-opportunity/buyer :investor/legal-entity LEGAL-ENTITY-FIELDS]):
                                  (when-not (vector? k)
                                    [[:exit-opportunity/buyer k] v])))
                          (into {})
                          (remove (fn-> first (= [:exit-opportunity/buyer :investor/name])))
                          (sort-by (fn [[_ v]]
                                     (-> v
                                         :field/translations
                                         :en)))
                          doall)

        target-holding-schema (->> (ref-schema :entity.type/holding)
                                   (keep (fn [[k v]]
                                           (when-not (vector? k)
                                             [[:exit-opportunity/target-holding k] v])))
                                   (into {})
                                   (remove (fn-> first (= [:exit-opportunity/target-holding
                                                           :holding/name])))
                                   (sort-by (fn [[_ v]]
                                              (-> v
                                                  :field/translations
                                                  :en)))
                                   doall)

        schema (if (and (not recalculate?)
                        calculated)
                 schema
                 (concat schema buyer-schema target-holding-schema))]
    (when (or recalculate?
              (not calculated))
      (reset! db/schema schema))
    schema))

;;precalculate for performance reasons
(defn keys-and-schemas
  []
  (precalculated-schema false))

(defn exit-opportunity-column-keys
  []
  (concat
   (when (session/is-admin?) [:db/id])
   (map first (keys-and-schemas))))

(def default-kanban-attributes
  [:exit-opportunity/cur-expected-EV
   :exit-opportunity/buyer
   :exit-opportunity/status])

(defn visible-keys-and-schemas
  []
  (let [{:keys [attributes footer-1 footer-2]} @db/card-settings
        visible-attributes
        (set (concat @db/selected-columns
                     attributes
                     default-kanban-attributes
                     [footer-1 footer-2
                      (entity-types/type->owner-attribute :entity.type/exit-opportunity)]))]
    (->> (keys-and-schemas)
         (filter (fn [[k fs]]
                   (some #{k} visible-attributes))))))

(declare expanded? toggle-expand!)

(defn entity-type-name
  [entity-type]
  (-> entity-type-names/entities
      (get entity-type)
      :field/translations
      :en))

(defn column-tabs
  []
  [(let [entity-type :entity.type/exit-opportunity]
     {:key entity-type
      :label (loc/tr :entity-type-fields [(entity-type-name entity-type)])})
   {:key :entity.type/investor
    :label (loc/tr :entity-type-fields [(loc/tr :buyer)])}
   {:key :entity.type/holding
    :label (loc/tr :entity-type-fields [(loc/tr :target-holding)])}])

(defn resolve-tab
  [field]
  (let [buyer-types [:entity.type/investor]
        ref-field? (and (vector? field)
                        (keyword? (first field))
                        (keyword? (second field)))
        [ref attr] (when ref-field?
                     field)
        buyer? (and ref-field?
                    (= ref :exit-opportunity/buyer))
        target-holding? (and ref-field?
                             (= ref :exit-opportunity/target-holding))]
    (cond
      (keyword? field)
      :entity.type/exit-opportunity
      buyer?
      :entity.type/investor
      target-holding?
      :entity.type/holding
      :else
      :unknown)))

;;necessary arguments to use common grid functions
(defn setup-args
  []
  {:state                 db/exit-opportunities
   :entity-type           :entity.type/exit-opportunity
   :modal-state db/modal-state
   :selected-columns-state db/selected-columns
   :ordered-columns-state db/ordered-columns
   :filters-state         db/exit-opportunity-filters
   :view-settings-state   db/view-settings
   :column-widths-state   db/column-widths
   :selected-pipeline     @session/selected-exit-oppo-pipeline
   :ls-path               ls-path
   :containing-entity     (->> @session/selected-exit-oppo-pipeline
                               (get @session/entities))
   :kanban-args           {:default-grouped-by  :exit-opportunity/stage
                           :kanban-state        db/kanban
                           :grouped-by-state    db/grouped-by
                           :card-settings-state db/card-settings
                           ;;for long card view:
                           :default-attributes  default-kanban-attributes
                           :expanded-state      db/expanded
                           :sorted-kanban-entities-state db/sorted-kanban-entities
                           :lists-state         db/lists
                           :expanded?           expanded?
                           :toggle-expand!      toggle-expand!}
   :kanban?               true
   :column-keys           exit-opportunity-column-keys
   :column-tabs           (column-tabs)
   :resolve-tab           resolve-tab
   :default-columns       columns/default-columns
   :mandatory?            columns/mandatory?
   :visible-keys-and-schemas-fn visible-keys-and-schemas
   :custom-filters        {:exit-opportunity/pipeline
                           {:operand :operand/all-of
                            :lower-bound-value
                            #{@session/selected-exit-oppo-pipeline}}}})

(defn resolve-column-key-universe
  []
  (grid/resolve-column-key-universe (setup-args)))

(defn resolve-column-keys
  []
  (grid/resolve-column-keys (setup-args)))

(defn cleanup
  []
  (when-let [tracker (:tracker-1 @db/exit-opportunities)]
    (r/dispose! tracker))
  (when-let [tracker (:tracker-2 @db/exit-opportunities)]
    (r/dispose! tracker))
  (when-let [tracker (:tracker-3 @db/exit-opportunities)]
    (r/dispose! tracker))

  (swap! db/exit-opportunities dissoc
    :loaded
    :schema
    :entities
    :entity-types
    :view-settings
    :sorted-grid-entities
    :sorted-kanban-entities
    :search
    :kanban
    :selected
    :grid-entities))

(defn setup-column-state!
  [view-settings]
  (reset! db/view-settings view-settings)
  (when (nil? @db/selected-columns)
    (let [default-view-settings (->> (named-views)
                                     first
                                     :named-view/settings)]
      (reset! db/view-settings default-view-settings)
      (ls/set-in (ls-path) default-view-settings)))
  (grid/recalculate (assoc (setup-args) :re-sort? true)))

(defn exit-opportunities-updates
  []
  (let [exit-opportunities (->> @session/all-exit-opportunities
                                 (cu/filter-by :exit-opportunity/pipeline
                                               @session/selected-exit-oppo-pipeline))]
    (swap! db/exit-opportunities assoc :grid-entities exit-opportunities)))

(defn permission-updates
  []
  (let [current-permissions @session/current-permissions]
    (when current-permissions
      (precalculated-schema true))))

(defn trigger-recalculation
  []
  (let [permissions-trigger @db/schema
        entities-trigger @db/grid-entities]
    (when (or permissions-trigger entities-trigger)
      (fu/timeout 10
                  (fn []
                    (grid/recalculate (assoc (setup-args) :stale-sort? true))
                    (swap! db/exit-opportunities assoc :loaded true)
                    (deref db/exit-opportunities))))))

(defn setup
  [closed-atom?]
  (when-not @closed-atom?
    (if (empty? (ls/get-in (ls-path)))
      (load-view! (first (named-views)))
      (reset! db/view-settings (ls/get-in (ls-path))))
    (swap! db/exit-opportunities
           assoc
           :tracker-1 (r/track! exit-opportunities-updates)
           :tracker-2 (r/track! permission-updates)
           :tracker-3 (r/track! trigger-recalculation))
    (setup-column-state! (ls/get-in (ls-path)))))

(defn toggle-quick-filters!
  []
  (swap! db/exit-opportunities update :show-quick-filters? not))

(defn switch-mode!
  [current-mode]
  (let [new-mode (if (= current-mode :grid-mode) :board-mode :grid-mode)]
    (swap! db/view-settings assoc :view-mode new-mode)
    (ls/update-in (ls-path) assoc :view-mode new-mode)))

(defn mass-delete!
  []
  (-> (conn/sendp! :exit-opportunity/mass-action
                   {:action :delete-exit-opportunities
                    :exit-opportunity-ids (grid/get-selected-items (setup-args))})
      (p/then (fn [args]
                (swap! db/exit-opportunities assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to delete selected exit-opportunities" e)))))

(defn mass-apply-tags!
  [selected-tag]
  (-> (conn/sendp! :exit-opportunity/mass-action
                   {:action  :add-tag-to-all
                    :exit-opportunity-ids (grid/get-selected-items (setup-args))
                    :tag-ids (into [] selected-tag)})
      (p/then (fn [args]
                (swap! db/exit-opportunities assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to apply tags to selected exit-opportunities" e)))))

(defn mass-remove-tags!
  [selected-tags]
  (-> (conn/sendp! :exit-opportunity/mass-action
                   {:action  :remove-tags-from-all
                    :exit-opportunity-ids (grid/get-selected-items (setup-args))
                    :tag-ids (into [] selected-tags)})
      (p/then (fn [args]
                (swap! db/exit-opportunities assoc :selected {})))
      (p/catch (fn [e]
                 (logging/error "Unable to remove tags to selected exit-opportunities" e)))))

(defn open-selected!
  [_]
  (let [exit-opportunity-id (-> (grid/get-selected-items (setup-args))
                                 (first))]
    (routing/open-entity exit-opportunity-id)))

(defn delete-selected-clicked
  [_]
  (modals/open-modal!
   confirmation/modal-key
   {:body          [:div
                    [:p (loc/tr :confirm-delete-selected)]]
    :confirm-text  (loc/tr :confirm-delete-selected-button)
    :checkbox-text (loc/tr :confirm-delete-selected-checkbox)
    :on-confirm    #(mass-delete!)}))

(defn expanded?
  [entity-id]
  (let [card-mode (or (:card-mode @db/kanban)
                      :short-card)
        individual (get @db/expanded entity-id)]
    (or (and (= card-mode :short-card)
             individual)
        (and (= card-mode :long-card)
             (not individual)))))

(defn toggle-expand!
  [entity-id]
  (let [expanded? (get @db/expanded entity-id)]
    (if expanded?
      (swap! db/expanded dissoc entity-id)
      (swap! db/expanded assoc entity-id true))))

(defn show-collapse-all?
  []
  (let [card-mode (or (:card-mode @db/kanban)
                      :short-card)
        individual-count (count @db/expanded)
        total-entity-count (count @db/sorted-kanban-entities)]
    (or (and (= card-mode :short-card)
             (> individual-count 0))
        (and (= card-mode :long-card)
             (< individual-count total-entity-count)))))

(defn expand-all!
  []
  (swap! db/kanban assoc :card-mode :long-card)
  (reset! db/expanded {}))

(defn collapse-all!
  []
  (swap! db/kanban assoc :card-mode :short-card)
  (reset! db/expanded {}))

(defn open-card-settings!
  []
  (swap! db/kanban assoc :card-settings? true))

(defn close-card-settings!
  []
  (swap! db/kanban dissoc :card-settings?))

(defn resurrect!
  [entity]
  (exit-opportunity-actions/*->resurrect!
   {:exit-opportunity-id (:db/id entity)}
   (fn [_])
   (fn [err]
     (logging/error "Failed to reactivate froppo " err))))

(defn won!
  [{:keys [entity _reset-focus!]}]
  (modals/open-modal!
   confirmation/modal-key
   {:body         [:div.text-center
                   [:p (loc/tr :exit-opportunity-confirm-won)]]
    :confirm-text (loc/tr :confirm)
    :confirm-icon ""
    :skip-checkbox? true
       ;;:title          (loc/tr :submit)
    :on-confirm   (fn [_]
                    (exit-opportunity-actions/*->won!
                     {:exit-opportunity-id (:db/id entity)}
                     (fn [_])
                     (fn [err]
                       (logging/error "Failed to set exit oppo as Won " err))))}))
